export default __webpack_public_path__ + "static/media/Button-PromoPerks.ba192849.svg";